(function () {
  const changeColor = document.querySelectorAll('[data-action="change_color"]');

  const imageProduct = document.querySelectorAll(
    '[data-target="change_color"]'
  );

  [...changeColor].map((button) => {
    button.addEventListener("click", (e) => {
      const rotate = button.dataset.hue_rotate;

      [...imageProduct].map((image) => {
        if (rotate === "black") {
          image.style.filter = `grayscale(2)`;
        } else {
          image.style.filter = `hue-rotate(${rotate}deg)`;
        }
      });
    });
  });
})();
